
import React, {useState} from "react";
import {ModalWrapper, Reoverlay} from "reoverlay";
import 'reoverlay/lib/ModalWrapper.css';
import Button from "../Button";

import { FaRegQuestionCircle } from "react-icons/fa";
const EstateGuideModal=(props)=>{
    const {slides=[]}=props;
    const [currentSlideIndex,setCurrentSlideIndex]=useState(0)
    const handleNext=()=>{
        if(currentSlideIndex<slides.length-1){
            setCurrentSlideIndex(currentSlideIndex+1)
        }else {
            Reoverlay.hideModal()
        }
    }
    const handlePrev=()=>{
        if(currentSlideIndex>0){
            setCurrentSlideIndex(currentSlideIndex-1)
        }else {
            Reoverlay.hideModal()
        }
    }

    return <ModalWrapper  onClose={()=>{}}  animation="slideDown" contentContainerClassName="w-11/12 md:w-6/12  flex flex-col justify-center items-center flex-col md:8/12 lg:w-4/12 xl:w-3/12 p-5 rounded-xl">
        {slides.map((slide,index)=>{
            return <div key={index} className={`${index!==currentSlideIndex ? 'hidden':'flex flex-col items-center justify-center'}`}>
                    <h1 className="font-bold text-center mb-1 text-2xl">{slide.title}</h1>
                    <p className={`font-semibold text-center mb-3 ${slide.status ? '':'text-red-500'}`}>{slide.description}</p>
                    <img className="w-full mb-2 " src={slide.image} alt=""/>
                   </div>
        })}

        <div className={`w-full mt-2 grid gap-2 pt-2 border-t  grid-cols-2`}>
            {<Button onClick={handlePrev} rounded="rounded-lg" theme="light" className="text-sm">{currentSlideIndex===0 ? 'بستن':'قبلی'}</Button> }
            {<Button onClick={handleNext}  rounded="rounded-lg" theme="green" className="text-sm">{currentSlideIndex===(slides.length-1) ? 'بستن' :'بعدی'}</Button> }
        </div>


    </ModalWrapper>
}
export default EstateGuideModal;